//export const StatesNames:string[]=['create','progress','captin','return','deliverd'];
export enum STATES_NAMES{
    CREATED = 0,
    IN_PROGRESS = 1,
    WITH_CAPTIN = 2,
    RETURNED = 3,
    DELIVERD = 4 
}

export const STATES={
    0: 'جديد',
    1: 'قيد التنفيذ',
    2: 'مع الكابتن',
    3: 'مرتجع',
    4: 'منفذ'
}

export const CHARGE_STATES={
    0: 'غير محصل',
    1: 'محصل مع الكابتن',
    2: 'مورد للفرع',
    3: 'مورد للعميل'
}

export const USER_STATUS={
    0: 'New',
    1: 'Verified',
    2: 'Blocked'
}

export const RECEIVE_OPTIONS={
    0: 'مرتجع جزئي',
    1: 'مرتجع استبدال',
    2: 'مرتجع استرجاع',
    4: 'لا'
}